import { render, staticRenderFns } from "./Plaid.vue?vue&type=template&id=f6b2d4b8"
import script from "./Plaid.vue?vue&type=script&lang=js"
export * from "./Plaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6b2d4b8')) {
      api.createRecord('f6b2d4b8', component.options)
    } else {
      api.reload('f6b2d4b8', component.options)
    }
    module.hot.accept("./Plaid.vue?vue&type=template&id=f6b2d4b8", function () {
      api.rerender('f6b2d4b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/company/Plaid.vue"
export default component.exports